import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    let bannerHome = new Swiper(".banner__slider", {
        watchOverflow: true,
        pagination: {
            el: ".banner-home-pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
    });

    let gallerySingleEnterprises = new Swiper(".gallery__slider", {
        watchOverflow: true,
        breakpoints: {
            1199: {
                pagination: {
                    el: ".gallery-pagination",
                    type: "bullets",
                    clickable: true,
                },
            },
        },
        navigation: {
            nextEl: '.gallery__next',
            prevEl: '.gallery__prev',
        },
    });
};
